import EfFootNotes from '@elem/ui/ef-foot-notes';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale } = useRouter();
    const { pageStatus } = useProductStore();

    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const EU_STATUSB = IS_EU_SITES && pageStatus === 'statusB';

    const configs = {
        text: EU_STATUSB || locale === 'ph' ? t('Q_text2') : t('Q_text'),
        langKey: 'delta3series',
        links:
            locale === 'ph'
                ? [t('Q_a1'), t('Q_a2'), t('Q_a3'), t('Q_a4'), t('Q_a5')]
                : IS_EU_SITES
                ? [t('Q_a1'), t('Q_a2'), t('Q_a3'), t('Q_a4'), t('Q_a5'), t('Q_a6'), t('Q_a7'), t('Q_a8'), t('Q_a9')]
                : [t('Q_a1'), t('Q_a2')],
        emails: [t('Q_mail1')],
    };

    return (
        <div className={styles.TheComp}>
            <EfFootNotes {...configs} />
        </div>
    );
}
